import React from "react";
import searchImage from "../assets/search.svg";
import { useDispatch, useSelector } from "react-redux";
import { useMatch, useNavigate } from "react-router-dom";
import { setSearchTerm } from "../RTK/Features/filter/filterSlice";
function Search() {
  const [text, setText] = React.useState("");
  const match = useMatch("/");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleSearchTerm = (e) => {
    e.preventDefault();
    dispatch(setSearchTerm(text));
    setText("");
    if (match) {
      navigate("/alltransactions");
    }
  };
  return (
    <div className="relative">
      <form onSubmit={handleSearchTerm}>
        <input
          className="bg-slate-600 text-slate-300 pl-8 pr-4 py-2 h-8 focus:cdoutline-0 w-48 focus:ring-[2px] focus:ring-slate-400 transition-all duration-500 ease-in focus:w-64"
          type="search"
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
        <img
          className="absolute w-4 h-4 top-[25%] left-[4%]"
          src={searchImage}
          alt="Search..."
        />
      </form>
    </div>
  );
}

export default Search;
